/**
 * Pattern titles, descriptions and user names come from users, so everything put into the page
 * as HTML goes through `escape`, and image addresses through `imageUrl`.
 */
const ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escape(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => ENTITIES[char]);
}

/** Template tag that escapes every interpolated value unless it is wrapped with `raw`. */
export function html(strings, ...values) {
  return strings.reduce((out, string, index) => {
    if (index === 0) return string;
    const value = values[index - 1];
    const text = value && value.__raw !== undefined
      ? value.__raw
      : Array.isArray(value) ? value.map((item) => (item && item.__raw !== undefined ? item.__raw : escape(item))).join('') : escape(value);
    return out + text + string;
  }, '');
}

export const raw = (value) => ({ __raw: String(value ?? '') });

/** Only same-site paths, http(s) and embedded images may be used as an image source. */
export function imageUrl(value) {
  const url = String(value ?? '').trim();
  if (/^data:image\/(png|jpe?g|gif|webp|svg\+xml)[;,]/i.test(url)) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/') && !url.startsWith('//')) return url;
  return '';
}

export function pluralise(count, word) {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}
